export default "__VITE_ASSET__346b8676__"